// client/src/routes/AppRoutes.js
import React, { Suspense, lazy } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { AuthProvider } from "../context/AuthContext";
import ProtectedRoute from "../components/Auth/ProtectedRoute.js";
import Login from "../components/Auth/Login";
import Unauthorized from "../components/Auth/Unauthorized.js";
import SmartRedirect from "../components/Auth/SmartRedirect.js"; // ✅ AGREGAR

// Componentes existentes
const Rutas = lazy(() => import("../components/Rutas/rutas"));
const Unidades = lazy(() => import("../components/Unidades/unidades"));
const Choferes = lazy(() => import("../components/Choferes/choferes"));
const PuntosRuta = lazy(() => import("../components/PuntosRuta/puntosRuta"));
const Bitacoras = lazy(() => import("../components/Bitacoras/bitacoras"));
const RegistroBitacoras = lazy(() => import("../components/RegistroBitacora/RegistroBitacora"));
const Viajes = lazy(() => import("../components/Viajes/viajes"));
const Calendario = lazy(() => import("../components/Viajes/calendario/calendario"));
const CalendarioMensual = lazy(() => import("../components/Viajes/calendario/CalendarioMensual"));
const ViajePorDocumentacion = lazy(() => import("../components/Viajes/ViajePorDocumentacion/ViajePorDocumentacion"));
import Navbar from "../components/NavBar/navbar";
const Clientes = lazy(() => import("../components/Clientes/clientes"));
const Analiticas = lazy(() => import("../components/Estadisticas/Analiticas/Analiticas.js"));
const Certificados = lazy(() => import("../components/Documentos/Certificados/Certificados"));
const GastosReales = lazy(() => import("../components/Documentos/GastosReales/GastosReales"));
const Flota = lazy(() => import("../components/Flota/MapaFlota.js"));
const Materiales = lazy(() => import("../components/Materiales/Materiales.js"));
const Vacaciones = lazy(() => import("../components/Vacaciones/Vacaciones.js"));
const Casetas = lazy(() => import("../components/Casetas/casetas.js"));
const Empleados = lazy(() => import("../components/Empleados/Empleados.js"));

// Nuevos componentes administrativos
const Usuarios = lazy(() => import("../components/Admin/Usuarios"));
const Roles = lazy(() => import("../components/Admin/Roles"));
const Permisos = lazy(() => import("../components/Admin/Permisos"));

import { useNavbar } from "../context/NavbarContext";
import "./AppRoutes.css";

function AppRoutes() {
  const { isOpen } = useNavbar();

  return (  
    <AuthProvider>
      <Router>
        <Suspense fallback={
          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
            <div style={{ width: 40, height: 40, border: '4px solid #e5edf5', borderTop: '4px solid #533afd', borderRadius: '50%', animation: 'spin 0.8s linear infinite' }} />
            <style>{`@keyframes spin { to { transform: rotate(360deg) } }`}</style>
          </div>
        }>
          <Routes>
          {/* Rutas públicas */}
          <Route path="/login" element={<Login />} />
          <Route path="/unauthorized" element={<Unauthorized />} />

          {/* ✅ CAMBIAR SOLO ESTA LÍNEA */}
          <Route path="/" element={<SmartRedirect />} />

          {/* ✅ MANTENER TODAS LAS RUTAS IGUAL */}
          <Route
            path="/viajes"
            element={
              <ProtectedRoute requiredPermissions={["viajes.leer"]}>
                <div className="appDiv">
                  <div className={`navbarApp ${isOpen ? "opened" : "closed"}`}>
                    <Navbar />
                  </div>
                  <div className="mainApp">
                    <Viajes />
                  </div>
                </div>
              </ProtectedRoute>
            }
          />
          <Route
            path="/viajes/por-documentacion"
            element={
              <ProtectedRoute requiredPermissions={["viajes.crear"]}>
                <div className="appDiv">
                  <div className={`navbarApp ${isOpen ? "opened" : "closed"}`}>
                    <Navbar />
                  </div>
                  <div className="mainApp">
                    <ViajePorDocumentacion />
                  </div>
                </div>
              </ProtectedRoute>
            }
          />
          <Route
            path="/calendario"
            element={
              <ProtectedRoute requiredPermissions={["viajes.leer"]}>
                <div className="appDiv">
                  <div className={`navbarApp ${isOpen ? "opened" : "closed"}`}>
                    <Navbar />
                  </div>
                  <div className="mainApp">
                    <Calendario />
                  </div>
                </div>
              </ProtectedRoute>
            }
          />
          <Route
            path="/calendario/mensual"
            element={
              <ProtectedRoute requiredPermissions={["viajes.leer"]}>
                <div className="appDiv">
                  <div className={`navbarApp ${isOpen ? "opened" : "closed"}`}>
                    <Navbar />
                  </div>
                  <div className="mainApp">
                    <CalendarioMensual />
                  </div>
                </div>
              </ProtectedRoute>
            }
          />
          <Route
            path="/vacaciones"
            element={
              <ProtectedRoute requiredPermissions={["vacaciones.leer"]}>
                <div className="appDiv">
                  <div className={`navbarApp ${isOpen ? "opened" : "closed"}`}>
                    <Navbar />
                  </div>
                  <div className="mainApp">
                    <Vacaciones />
                  </div>
                </div>
              </ProtectedRoute>
            }
          />
          {/* Alias del módulo anterior: los enlaces viejos a /asistencia
              siguen funcionando. El pase de lista se retiró, pero la tabla
              asistencias sigue siendo el espejo de las vacaciones. */}
          <Route
            path="/asistencia"
            element={<Navigate to="/vacaciones" replace />}
          />

          <Route
            path="/empleados"
            element={
              <ProtectedRoute requiredPermissions={["choferes.leer"]}>
                <div className="appDiv">
                  <div className={`navbarApp ${isOpen ? "opened" : "closed"}`}>
                    <Navbar />
                  </div>
                  <div className="mainApp">
                    <Empleados />
                  </div>
                </div>
              </ProtectedRoute>
            }
          />

          <Route
            path="/certificados"
            element={
              <ProtectedRoute requiredPermissions={["viajes.leer"]}>
                <div className="appDiv">
                  <div className={`navbarApp ${isOpen ? "opened" : "closed"}`}>
                    <Navbar />
                  </div>
                  <div className="mainApp">
                    <Certificados />
                  </div>
                </div>
              </ProtectedRoute>
            }
          />
          <Route
            path="/GastosReales"
            element={
              <ProtectedRoute requiredPermissions={["viajes.leer"]}>
                <div className="appDiv">
                  <div className={`navbarApp ${isOpen ? "opened" : "closed"}`}>
                    <Navbar />
                  </div>
                  <div className="mainApp">
                    <GastosReales />
                  </div>
                </div>
              </ProtectedRoute>
            }
          />

          <Route
            path="/choferes"
            element={
              <ProtectedRoute requiredPermissions={["choferes.leer"]}>
                <div className="appDiv">
                  <div className={`navbarApp ${isOpen ? "opened" : "closed"}`}>
                    <Navbar />
                  </div>
                  <div className="mainApp">
                    <Choferes />
                  </div>
                </div>
              </ProtectedRoute>
            }
          />

          <Route
            path="/unidades"
            element={
              <ProtectedRoute requiredPermissions={["unidades.leer"]}>
                <div className="appDiv">
                  <div className={`navbarApp ${isOpen ? "opened" : "closed"}`}>
                    <Navbar />
                  </div>
                  <div className="mainApp">
                    <Unidades />
                  </div>
                </div>
              </ProtectedRoute>
            }
          />

          <Route
            path="/clientes"
            element={
              <ProtectedRoute requiredPermissions={["clientes.leer"]}>
                <div className="appDiv">
                  <div className={`navbarApp ${isOpen ? "opened" : "closed"}`}>
                    <Navbar />
                  </div>
                  <div className="mainApp">
                    <Clientes />
                  </div>
                </div>
              </ProtectedRoute>
            }
          />

          <Route
            path="/rutas"
            element={
              <ProtectedRoute requiredPermissions={["rutas.leer"]}>
                <div className="appDiv">
                  <div className={`navbarApp ${isOpen ? "opened" : "closed"}`}>
                    <Navbar />
                  </div>
                  <div className="mainApp">
                    <Rutas />
                  </div>
                </div>
              </ProtectedRoute>
            }
          />

          <Route
            path="/puntosRuta"
            element={
              <ProtectedRoute requiredPermissions={["rutas.leer"]}>
                <div className="appDiv">
                  <div className={`navbarApp ${isOpen ? "opened" : "closed"}`}>
                    <Navbar />
                  </div>
                  <div className="mainApp">
                    <PuntosRuta />
                  </div>
                </div>
              </ProtectedRoute>
            }
          />
          <Route
            path="/analiticas"
            element={
              <ProtectedRoute requiredPermissions={["viajes.leer"]}>
                <div className="appDiv">
                  <div className={`navbarApp ${isOpen ? "opened" : "closed"}`}>
                    <Navbar />
                  </div>
                  <div className="mainApp">
                    <Analiticas />
                  </div>
                </div>
              </ProtectedRoute>
            }
          />
          <Route
            path="/casetas"
            element={
              <ProtectedRoute requiredPermissions={["viajes.leer"]}>
                <div className="appDiv">
                  <div className={`navbarApp ${isOpen ? "opened" : "closed"}`}>
                    <Navbar />
                  </div>
                  <div className="mainApp">
                    <Casetas />
                  </div>
                </div>
              </ProtectedRoute>
            }
          />

          <Route
            path="/bitacoras"
            element={
              <ProtectedRoute requiredPermissions={["bitacoras.leer"]}>
                {" "}
                <div className="appDiv">
                  <div className={`navbarApp ${isOpen ? "opened" : "closed"}`}>
                    <Navbar />
                  </div>
                  <div className="mainApp">
                    <Bitacoras />
                  </div>
                </div>
              </ProtectedRoute>
            }
          />

          <Route
            path="/registroBitacoras"
            element={
              <ProtectedRoute requiredPermissions={["registros_bitacora.leer"]}>
                {" "}
                <div className="appDiv">
                  <div className={`navbarApp ${isOpen ? "opened" : "closed"}`}>
                    <Navbar />
                  </div>
                  <div className="mainApp">
                    <RegistroBitacoras />
                  </div>
                </div>
              </ProtectedRoute>
            }
          />
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute requiredPermissions={["viajes.leer"]}>
                <div className="appDiv">
                  <div className={`navbarApp ${isOpen ? "opened" : "closed"}`}>
                    <Navbar />
                  </div>
                  <div className="mainApp">
                    <Flota />
                  </div>
                </div>
              </ProtectedRoute>
            }
          />
          <Route
            path="/materiales"
            element={
              <ProtectedRoute requiredPermissions={["viajes.leer"]}>
                <div className="appDiv">
                  <div className={`navbarApp ${isOpen ? "opened" : "closed"}`}>
                    <Navbar />
                  </div>
                  <div className="mainApp">
                    <Materiales />
                  </div>
                </div>
              </ProtectedRoute>
            }
          />

          {/* Rutas administrativas */}
          <Route
            path="/usuarios"
            element={
              <ProtectedRoute requiredPermissions={["usuarios.leer"]}>
                <div className="appDiv">
                  <div className={`navbarApp ${isOpen ? "opened" : "closed"}`}>
                    <Navbar />
                  </div>
                  <div className="mainApp">
                    <Usuarios />
                  </div>
                </div>
              </ProtectedRoute>
            }
          />

          <Route
            path="/roles"
            element={
              <ProtectedRoute requiredPermissions={["configuracion.editar"]}>
                <div className="appDiv">
                  <div className={`navbarApp ${isOpen ? "opened" : "closed"}`}>
                    <Navbar />
                  </div>
                  <div className="mainApp">
                    <Roles />
                  </div>
                </div>
              </ProtectedRoute>
            }
          />
          <Route
            path="/permisos"
            element={
              <ProtectedRoute requiredPermissions={["configuracion.ver"]}>
                <div className="appDiv">
                  <div className={`navbarApp ${isOpen ? "opened" : "closed"}`}>
                    <Navbar />
                  </div>
                  <div className="mainApp">
                    <Permisos />
                  </div>
                </div>
              </ProtectedRoute>
            }
          />

          {/* ✅ CAMBIAR TAMBIÉN LA RUTA 404 */}
          <Route path="*" element={<SmartRedirect />} />
        </Routes>
        </Suspense>
      </Router>
    </AuthProvider>
  );
}

export default AppRoutes;
